import { useGetExpenseReportQuery } from '@/features/slice/report';
import { mapExpenseReportListToCsvExport } from '@/modules/reports/expense/mapper';
import { jsonToCsv } from '@/utils/json-to-csv.util';

export const useExpenseReport = () => {
    const { data, isLoading, isFetching, isError, error } =
        useGetExpenseReportQuery({});
    const handleExportToPdf = () => {
        alert('Not implemented yet');
    };

    const handleExportToCSV = () => {
        jsonToCsv(
            mapExpenseReportListToCsvExport(data?.data ?? []),
            // TODO: Add timestamp to filename
            'expense_reports.csv',
        );
    };

    return {
        data,
        isLoading,
        isFetching,
        isError,
        error,

        handleExportToPdf,
        handleExportToCSV,
    };
};
